export class Menu {

    constructor(domElm) {
        this.domElm = domElm;

        // Get menu elements
        this.burgerMenu = this.domElm.querySelector(".burger-menu-button");
        this.menuElments = this.domElm.querySelectorAll(".menu-item-has-children > :first-child");

        this.addListeners();
    }


    addListeners() {
        // this.domElm.querySelector(".burger-menu-button");
        this.burgerMenu.addEventListener("click", () => {
            this.domElm.classList.toggle("open");
            document.body.classList.toggle("no-scroll");
        })

        this.menuElments.forEach((elm) => {
            elm.addEventListener("click", (ev) => {
                ev.preventDefault();

                elm.classList.toggle("open");
            })
        })
    }
}
